import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { ListingDataFormIO, TListingDataFormIOCodec } from "../formIO/ListingDataFormIO";

export const ListingPerformancePagePartial: TRequiredCodec<{
    data: TListingDataFormIOCodec;
}> = required({
    data: ListingDataFormIO,
});

export type TListingPerformancePagePartialCodec = typeof ListingPerformancePagePartial;